import { render } from "./ContactInformation.vue?vue&type=template&id=2b99232a&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"

import "./ContactInformation.vue?vue&type=style&index=0&id=2b99232a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b99232a"]])

export default __exports__